import { Routes } from '@angular/router';
import { NotAuthenticatedGuard } from './features/auth/guards/not-authenticated.guard';
import { AuthenticatedGuard } from './features/auth/guards/authenticated.guard';

export const routes: Routes = [
    {
        path: 'login',
        loadChildren: () => import('./layouts/auth-layout/auth-layout.routes').then((m) => m.routes),
        canMatch: [NotAuthenticatedGuard]
    },
    {
        path: '',
        loadChildren: () => import('./layouts/main-layout/main-layout.routes').then((m) => m.routes),
        canMatch: [AuthenticatedGuard]
    },
];
